import { useCallback, useEffect, useState } from "react";
import { FetchAccountFeatures } from "../services/account";
import { useRefreshOnAccountFeaturesUpdated } from "./useRefreshOnAccountFeaturesUpdated";

/**
 * Load a single account feature toggle by key (e.g. workflows, workflows_canvas, trustvid_crm).
 * Re-fetches when Feature Toggles are saved for this account (no full page refresh needed).
 */
export const useAccountFeatureToggle = (accountId, featureKey) => {
  const [isEnabled, setIsEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!accountId || !featureKey) {
      setIsEnabled(false);
      return;
    }
    setIsLoading(true);
    const response = await FetchAccountFeatures(accountId);
    setIsLoading(false);
    if (!response || response?.error) {
      setIsEnabled(false);
      return;
    }
    const features = Array.isArray(response?.features) ? response.features : [];
    const key = String(featureKey).toLowerCase();
    const match = features.find((item) => String(item?.key || "").toLowerCase() === key);
    setIsEnabled(Boolean(match?.enabled));
  }, [accountId, featureKey]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useRefreshOnAccountFeaturesUpdated(accountId, refresh);

  return { isEnabled, isLoading, refresh };
};
